module.exports = __webpack_public_path__ + "img/face-grin.1b20f8ea.svg";